webpackJsonp([93],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports) {

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  scopeId,
  cssModules
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  // inject cssModules
  if (cssModules) {
    var computed = Object.create(options.computed || null)
    Object.keys(cssModules).forEach(function (key) {
      var module = cssModules[key]
      computed[key] = function () { return module }
    })
    options.computed = computed
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 7 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap) {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
  var base64 = new Buffer(JSON.stringify(sourceMap)).toString('base64');
  var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

  return '/*# ' + data + ' */';
}


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = addStylesClient;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__listToStyles__ = __webpack_require__(258);
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__listToStyles__["a" /* default */])(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__listToStyles__["a" /* default */])(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsbridge = __webpack_require__(42);

Object.keys(_jsbridge).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _jsbridge[key];
    }
  });
});

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.$PUT = exports.$POSTPANDA = exports.$POST = exports.$JSONP = exports.$GETPANDA = exports.$GET = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _wui = __webpack_require__(11);

var _wui2 = _interopRequireDefault(_wui);

var _config = __webpack_require__(147);

var _config2 = _interopRequireDefault(_config);

var _native = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var host = _config2.default.host + (_config2.default.port ? ':' + _config2.default.port : _config2.default.port) + _config2.default.base;

var _options = {
    timeout: 15000,
    onTimeout: function onTimeout() {
        _wui2.default.Toast.show('网络异常,请稍后重试');
    }
};

var $GET = exports.$GET = function $GET(url, params, opts) {
    opts = _extends({}, _options, opts || {});
    url = url.indexOf('http') === 0 ? url : host + url;
    params = _extends({}, params || {}, {
        t: Date.now
    });
    opts = _extends({}, opts, {
        params: params
    });
    return new Promise(function (resolve, reject) {
        _vue2.default.http.get(url, opts).then(function (res) {
            resolve(res.json());
        }, handleError(reject));
    });
};

var $GETPANDA = exports.$GETPANDA = function $GETPANDA(url, params, opts) {
    opts = _extends({}, _options, opts || {});

    url = url.indexOf('http') === 0 ? url : '/panda_front/pandaactivity' + url;
    params = _extends({}, params || {}, {
        t: Date.now
    });
    opts = _extends({}, opts, {
        params: params
    });
    return new Promise(function (resolve, reject) {
        _vue2.default.http.get(url, opts).then(function (res) {
            resolve(res.json());
        }, handleError(reject));
    });
};

var $JSONP = exports.$JSONP = function $JSONP(url, params, opts) {
    opts = _extends({}, _options, opts || {});
    params = _extends({}, params || {}, {
        t: Date.now
    });
    opts = _extends({}, opts, {
        params: params
    });
    url = url.indexOf('http') === 0 ? url : host + url;
    return new Promise(function (resolve, reject) {
        _vue2.default.http.jsonp(url, opts).then(function (res) {
            resolve(res.json());
        }, handleError(reject));
    });
};

var $POST = exports.$POST = function $POST(url, body, opts) {
    opts = _extends({}, _options, opts || {});
    url = url.indexOf('http') === 0 ? url : host + url;
    return new Promise(function (resolve, reject) {
        _vue2.default.http.post(url, body, opts).then(function (res) {
            resolve(res.json());
        }, handleError(reject));
    });
};

var $POSTPANDA = exports.$POSTPANDA = function $POSTPANDA(url, body, opts) {
    opts = _extends({}, _options, opts || {});

    url = url.indexOf('http') === 0 ? url : '/panda_front/pandaactivity' + url;
    return new Promise(function (resolve, reject) {
        _vue2.default.http.post(url, body, opts).then(function (res) {
            resolve(res.json());
        }, handleError(reject));
    });
};

var $PUT = exports.$PUT = function $PUT(url, body, opts) {
    opts = _extends({}, _options, opts || {});
    url = url.indexOf('http') === 0 ? url : host + url;
    return new Promise(function (resolve, reject) {
        _vue2.default.http.put(url, body, opts).then(function (res) {
            resolve(res.json());
        }, handleError(reject));
    });
};

function handleError(reject) {
    return function (err) {
        if (!err || !err.data) {
            return reject({});
        }

        if (err.data.errorCode == 5001 || err.data.errorCode == 1012 || err.data.errorCode == 1011) {
            return (0, _native.goLogin)().then(function (res) {
                window.location.reload();
            });
        } else if (err.data.errorMessage && err.data.errorMessage.indexOf('Cannot get Jedis connection') > -1) {
            err.data.errorMessage = '连接超时,请重试';
        }

        reject(err.data);
    };
}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sendEmailVerifyCode = sendEmailVerifyCode;
exports.sendEmailVerifyCodeNew = sendEmailVerifyCodeNew;
exports.preRegist = preRegist;
exports.sendCode = sendCode;
exports.sendMobileVerifyCodeV2 = sendMobileVerifyCodeV2;
exports.getShortLink = getShortLink;
exports.sendUserMobileVerifyCodeV2 = sendUserMobileVerifyCodeV2;
exports.refreshCaptcha = refreshCaptcha;
exports.fetchUserInfo = fetchUserInfo;
exports.generateBarcode = generateBarcode;
exports.fetchQuota = fetchQuota;
exports.checkLogin = checkLogin;
exports.refreshAppconfig = refreshAppconfig;
exports.homeproductsrate = homeproductsrate;
exports.getLatestVersion = getLatestVersion;
exports.questionnaireSave = questionnaireSave;
exports.queryMobile = queryMobile;
exports.memberRedPacket = memberRedPacket;
exports.walletLink = walletLink;
exports.wddLink = wddLink;
exports.threeUserLogin = threeUserLogin;
exports.threeUserInfo = threeUserInfo;
exports.menuUrl = menuUrl;
exports.menuList = menuList;
exports.walletSendCoupon = walletSendCoupon;
exports.getSimpleCreditApply = getSimpleCreditApply;
exports.recordMarketingMobile = recordMarketingMobile;
exports.wxSignature = wxSignature;

var _http = __webpack_require__(18);

function sendEmailVerifyCode(mail, opts) {
    return (0, _http.$POST)('/api/v1/minicash/fetchMailVerifyCode', { workEmail: mail }, opts);
}

function sendEmailVerifyCodeNew(mail, opts) {
    return (0, _http.$POST)('/api/v1/minicash/sendemailverifycode', { workEmail: mail }, opts);
}

function preRegist(body, opts) {
    return (0, _http.$POST)('/api/v1/preRegister', body, opts);
}

function sendCode(body, opts) {
    return (0, _http.$POST)('/api/v1/verifycode', body, opts);
}

function sendMobileVerifyCodeV2(body, opts) {
    return (0, _http.$POST)('/api/v2/verifycode', body, opts);
}

function getShortLink(body, opts) {
    return (0, _http.$POST)('/api/v1/sr/get/short/link', body, opts);
}

function sendUserMobileVerifyCodeV2(body, opts) {
    return (0, _http.$POST)('/api/v2/user/verifycode', body, opts);
}

function refreshCaptcha(body, opts) {
    return (0, _http.$POST)('/api/v1/refreshcaptcha', body, opts);
}

function fetchUserInfo(params, opts) {
    return (0, _http.$GET)('/api/v1/user/myinfo', params, opts);
}

function generateBarcode(params, opts) {
    return (0, _http.$GET)('/api/v1/generateBarcode', params, opts);
}

function fetchQuota(params, opts) {
    return (0, _http.$GET)('/api/v1/minicash/user/welcome', params, opts);
}

function checkLogin(vue, opts) {
    return vue.http.get('/timesloan/api/v1/user/myinfo', opts);
}

function refreshAppconfig(body, opts) {
    return (0, _http.$GET)('/appconfig', body, opts);
}

function homeproductsrate(body, opts) {
    return (0, _http.$GET)('/v3/homeproductsrate', body, opts);
}

function getLatestVersion(body, opts) {
    return (0, _http.$GET)('/api/v1/app/latestVersion', body, opts);
}

function questionnaireSave(body, opts) {
    return (0, _http.$POST)('/api/v1/sports/questionnaire/save', body, opts);
}

function queryMobile(body, opts) {
    return (0, _http.$GET)('/api/v1/everbrightBank/queryMobile', body, opts);
}

function memberRedPacket(body, opts) {
    return (0, _http.$POST)('/api/v1/red/proportion', body, opts);
}

function walletLink(body, opts) {
    return (0, _http.$POST)('/api/v1/wallet/link', body, opts);
}

function wddLink(body, opts) {
    return (0, _http.$POST)('/api/v1/sr/get/short/link', body, opts);
}

function threeUserLogin(body, opts) {
    return (0, _http.$POST)('/three/loan/user/login', body, opts);
}

function threeUserInfo(body, opts) {
    return (0, _http.$POST)('/three/loan/user/info/query', body, opts);
}

function menuUrl(body, opts) {
    return (0, _http.$POST)('/api/v1/menu/url', body, opts);
}

function menuList(body, opts) {
    return (0, _http.$POST)('/api/v1/menu/list', body, opts);
}

function walletSendCoupon(body, opts) {
    return (0, _http.$POST)('/api/v1/wallet/sendCoupon', body, opts);
}

function getSimpleCreditApply(body, opts) {
    return (0, _http.$POST)('/api/v1/simpleCreditApply', body, opts);
}

function recordMarketingMobile(body, opts) {
    return (0, _http.$POST)('/api/v1/marketing/mobile/records', body, opts);
}

function wxSignature(pageUrl, opts) {
    var url = '/api/v1/publicNo/auth/jsSignature';
    return (0, _http.$GET)(url, { pageUrl: pageUrl }, opts);
}

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.numberic = numberic;
exports.verifyCarNumber = verifyCarNumber;
exports.verifyEmail = verifyEmail;
exports.getSex = getSex;
exports.isEmpty = isEmpty;
exports.getServerUrl = getServerUrl;
exports.goWxAppUrl = goWxAppUrl;
var UA = window.navigator.userAgent,
    ua = UA.toLowerCase();
function numberic(val, n) {
    var p = Number(val).toFixed(n || 2);
    var ary = p.split('.'),
        i = ary[0],
        f = ary[1];
    i = i.split('').reverse().join('').match(new RegExp('([A-Za-z0-9]{1,3})+?', 'g')).join(',').split('').reverse().join('');

    return i + '.' + f;
}

function verifyCarNumber(number) {
    var re = /^[\u4e00-\u9fa5]{1}[A-Za-z]{1}[A-Za-z_0-9]{5,6}$/;
    return re.test(String(number));
}

function verifyEmail(email) {
    var re = /^[A-Za-z0-9]+([._\\-]*[A-Za-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
    return email && typeof email === 'string' && re.test(email);
}

function verifyIdCard(code) {
    var city = {
        11: '北京',
        12: '天津',
        13: '河北',
        14: '山西',
        15: '内蒙古',
        21: '辽宁',
        22: '吉林',
        23: '黑龙江 ',
        31: '上海',
        32: '江苏',
        33: '浙江',
        34: '安徽',
        35: '福建',
        36: '江西',
        37: '山东',
        41: '河南',
        42: '湖北 ',
        43: '湖南',
        44: '广东',
        45: '广西',
        46: '海南',
        50: '重庆',
        51: '四川',
        52: '贵州',
        53: '云南',
        54: '西藏 ',
        61: '陕西',
        62: '甘肃',
        63: '青海',
        64: '宁夏',
        65: '新疆',
        71: '台湾',
        81: '香港',
        82: '澳门',
        91: '国外 '
    };
    var tip = '';
    var pass = true;
    if (typeof code == 'number') {
        code = String(code);
    }

    if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
        tip = '身份证号格式错误';
        pass = false;
    } else if (!city[code.substr(0, 2)]) {
        tip = '地址编码错误';
        pass = false;
    } else {
        if (code.length == 18) {
            code = code.split('');

            var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];

            var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
            var sum = 0;
            var ai = 0;
            var wi = 0;
            for (var i = 0; i < 17; i++) {
                ai = code[i];
                wi = factor[i];
                sum += ai * wi;
            }
            var last = parity[sum % 11];
            if (parity[sum % 11] != code[17]) {
                tip = '校验位错误';
                pass = false;
            }
        }
    }
    if (!pass) console.log(tip);
    return pass;
}

function getSex(code) {
    var sexno, sex;
    if (code.length == 18) {
        sexno = code.substring(16, 17);
    } else if (code.length == 15) {
        sexno = code.substring(14, 15);
    } else {
        return '';
    }
    var tempid = sexno % 2;
    if (tempid == 0) {
        sex = 'female';
    } else {
        sex = 'male';
    }
    return sex;
}

var hasOwnProperty = Object.prototype.hasOwnProperty;

function isEmpty(obj) {
    if (obj == null) return true;

    if (obj.length > 0) return false;
    if (obj.length === 0) return true;

    if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') return true;

    for (var key in obj) {
        if (hasOwnProperty.call(obj, key)) return false;
    }

    return true;
}

var OS = exports.OS = {
    isIOS: /iphone|ipad|ipod|ios/.test(ua),
    isAndroid: ua.indexOf('android') > 0,
    isWechat: ua.indexOf('micromessenger') > 0,
    isWandaApp: ua.indexOf('com.wandaloans.timesloan') > 0,
    isSafari: false,
    isChrome: false,
    isBaidu: false,
    isLiebao: false,
    is360: false,
    isSougo: false,
    isUc: false,
    is2345: false,
    isQQ: false
};

if (ua.indexOf('ubrowser') > -1 || UA.indexOf('UC') > -1) {
    OS.isUc = true;
} else if (ua.indexOf('mqqbrowser') > -1) {
    OS.isQQ = true;
} else if (UA.indexOf('Baidu') > -1 || UA.indexOf('BIDUBrowser') > -1) {
    OS.isBaidu = true;
} else if (ua.indexOf('liebaofast') > -1) {
    OS.isLiebao = true;
} else if (UA.indexOf('360EE') > -1 || UA.indexOf('360SE') > -1) {
    OS.is360 = true;
} else if (UA.indexOf('MetaSr') > -1 || UA.indexOf('Sogou') > -1) {
    OS.isSougo = true;
} else if (UA.indexOf('2345Explorer') > -1) {
    OS.is2345 = true;
} else if (UA.indexOf('Chrome') > -1 || UA.indexOf('CriOS') > -1) {
    OS.isChrome = true;
} else if (ua.indexOf('safari') > -1) {
    OS.isSafari = true;
}

OS.version = _getOSVersion();
OS.appVersion = _getWandadaiVersion();

function _getOSVersion() {
    if (OS.isIOS) {
        return ua.match(/OS\s+(\d)_\d+\s+like Mac OS X/);
    }
    if (OS.isAndroid) {
        ua.substr(ua.indexOf('Android') + 8, 3);
    }
}

function _getWandadaiVersion() {
    var v = ua.split(';')[1] || '';
    return (v.match(/\d+\.\d+\.\d+\((\d+)\)/) || [])[1] || '';
}

function getServerUrl() {
    var url = 'https://kf.uat.wandaph.com/webchat/web/h5?groupNo=wdd_web&tenantId=wanda&callee=wdd_h5';
    location.href = url;
}

function goWxAppUrl(channel) {
    console.log(channel);
    if (channel === 'wdd') {
        location.href = 'weixin://dl/business/?t=6Wc5cz6mqZa';
    } else if (channel === 'kyh') {
        location.href = 'weixin://dl/business/?t=KtxiwVxouxu';
    } else if (channel === 'wdph') {
        location.href = 'weixin://dl/business/?t=YuaX6PKh0el';
    } else {
        location.href = 'weixin://dl/business/?t=hDZ3Vt40t7t';
    }
}

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PrimaryButton = undefined;

var _primaryButton = __webpack_require__(69);

var _primaryButton2 = _interopRequireDefault(_primaryButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.PrimaryButton = _primaryButton2.default;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = function (vue) {
    vue.directive('fixed-bottom', function fixed(el, binding) {
        var ch = parseInt(document.documentElement.dataset.ch || document.documentElement.clientHeight);
        var btm = binding.value || 0;

        if (typeof btm !== 'number') {
            return console.error('the value of the directive fixed-bottom must be Number');
        }

        vue.nextTick(function () {
            var h = el.clientHeight;
            el.style.top = ch - h - btm + 'px';
        });

        window.addEventListener('resize', function () {
            vue.nextTick(function () {
                var h = el.clientHeight;
                var _ch = document.documentElement.clientHeight;

                if (Math.abs(ch - _ch) < 100) {
                    el.style.display = "";
                    el.style.top = _ch - h - btm + 'px';
                } else {
                    el.style.display = "none";
                }
            });
        }, false);
    });

    vue.directive('validate-input', {
        bind: function bind(el, binding, vnode) {
            var instance = vnode.componentInstance;
            var timmer = null,
                params = {
                delay: 3000
            };

            if (typeof binding.value !== 'function' && _typeof(binding.value) !== 'object') {
                return console.error('directive args mast be a Function or a Object');
            }

            if (typeof binding.value === 'function') {
                params = {
                    vfn: binding.value,
                    delay: 3000
                };
            } else {
                params = _extends({}, params, binding.value);
            }

            instance.$on('focus', function () {});

            instance.$on('blur', function () {
                if (timmer) {
                    clearTimeout(timmer);
                    timmer = null;
                }
                params.vfn().catch(function (err) {
                    instance.$emit('validate-error', err);
                    instance.$emit('validate-end');
                });

                instance.$emit('validate-end');
            });

            instance.$on('input', function () {
                instance.$emit('validate-error', '');
                instance.$emit('validate-start');
                if (timmer) {
                    clearTimeout(timmer);
                    timmer = null;
                }

                params.vfn().then(function () {
                    instance.$emit('validate-error', '');
                    instance.$emit('validate-end');
                }, function (err) {
                    timmer = setTimeout(function () {
                        instance.$emit('validate-error', err);
                        instance.$emit('validate-end');
                    }, params.delay);
                });
            });
        }
    });
};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (vue) {
  vue.filter('numberic', _tools.numberic);
};

var _tools = __webpack_require__(24);

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var trackPageView = exports.trackPageView = function trackPageView(pageUrl) {
    _hmt.push(['_trackPageview', pageUrl]);
};

var trackEvent = exports.trackEvent = function trackEvent(category, action, label, value) {
    _hmt.push(['_trackEvent', category, action, label, value]);
};

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.scanFace = exports.getCallandContact = exports.getImageInfo = exports.screenShots = exports.showToast = exports.rateApp = exports.sensorStop = exports.sensorStart = exports.scanIdCard = exports.startHwr = exports.getRiskData = exports.getDeviceInfo = exports.ymPageNameWithSeconds = exports.ymTrack = exports.getCity = exports.getCheckTradePwd = exports.setFingerPayPwd = exports.setTransactionPwd = exports.getTransactionPwd = exports.openShare = exports.getScreenInfo = exports.openOutSide = exports.selectShop = exports.openUrl = exports.goLogin = exports.goMyHome = exports.isApp = exports.goAppHome = exports.openChat = exports.openView = exports.pageControl = exports.scanQrCode = exports.setNavGation = exports.log = exports.getGPS = exports.showMessageBox = exports.getContacts = exports.setTitle = exports.registerNative = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _queryString = __webpack_require__(240);

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __fn_stack = [];

var callNative = function callNative(method, params) {
    return new Promise(function (resolve, reject) {
        var _fn = function _fn() {
            return window.WebViewJavascriptBridge.callHandler(method, params, function (res) {
                if (typeof res === 'string') {
                    res = JSON.parse(res);
                }

                if (res && res.status === 'success') {
                    resolve(res);
                } else {
                    reject(res);
                }
            });
        };

        if (!window.WebViewJavascriptBridge) {
            __fn_stack.push(_fn);
        } else {
            _fn();
        }
    });
};

var registerNative = exports.registerNative = function registerNative(listenName) {
    return new Promise(function (resolve, reject) {
        var _fn = function _fn() {
            return window.WebViewJavascriptBridge.registerHandler(listenName, function () {
                return resolve();
            });
        };
        try {
            if (!window.WebViewJavascriptBridge) {
                __fn_stack.push(_fn);
            } else {
                _fn();
            }
        } catch (error) {
            reject(error);
        }
    });
};

var setTitle = exports.setTitle = function setTitle(title) {
    return callNative('setTitle', { title: title });
};

var getContacts = exports.getContacts = function getContacts(params) {
    return callNative('getContacts', _extends({}, params));
};

var showMessageBox = exports.showMessageBox = function showMessageBox(params) {
    return callNative('showMessageBox', _extends({}, params));
};

var getGPS = exports.getGPS = function getGPS(prompt) {
    return callNative('getGPS', _extends({
        "promptOnDenied": "1",
        "promptTitle": "位置信息",
        "promptContent": "为增加您通过机会，请打开设备的GPS",
        "promptCancelTitle": "取消",
        "promptConfirmTitle": "确定"
    }, prompt));
};

var log = exports.log = function log(info) {
    return callNative('log', { info: info });
};

var setNavGation = exports.setNavGation = function setNavGation(params) {
    if (typeof params === 'string') {
        params = {
            navigatorTitle: params
        };
    }

    var navOpts = _extends({
        leftTitle: "<",
        leftAction: "back",
        leftUrl: "",
        rightTitle: "",
        rightAction: null,
        rightUrl: "",
        navigatorTitle: ""
    }, params);

    return callNative('updateBar', navOpts);
};

var scanQrCode = exports.scanQrCode = function scanQrCode(tips) {
    return callNative('scanQrCode', { tips: tips });
};

var pageControl = exports.pageControl = function pageControl(action) {
    return callNative('pageControl', { action: action });
};

var openView = exports.openView = function openView(view, params, delay) {
    return callNative('openUrl', { url: 'wdsd://' + view + '?' + _queryString2.default.stringify(params), delay: delay });
};

var openChat = exports.openChat = function openChat() {
    return openView('dcschat');
};

var goAppHome = exports.goAppHome = function goAppHome(delay) {
    return openView('home', { page: '1' }, delay);
};

function uaByKeyword(keyword) {
    var myua = navigator.userAgent.toLowerCase();
    var uaGroup = myua.split(' ');
    var uakw = '';
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = uaGroup[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var uaItem = _step.value;

            if (uaItem.indexOf(keyword) === 0) {
                uakw = uaItem;
                break;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return uakw;
}
var isApp = exports.isApp = function isApp() {
    if (!!uaByKeyword('wdph') || !!uaByKeyword('fbwdph')) {
        return 'WED';
    } else if (/com.wanda.kuaiyihua/i.test(navigator.userAgent)) {
        return 'KYH';
    } else if (/com.wandaloans/i.test(navigator.userAgent)) {
        return 'WDD';
    } else if (/MicroMessenger/i.test(navigator.userAgent)) {
        return 'WX';
    } else {
        return 'H5';
    }
};

var goMyHome = exports.goMyHome = function goMyHome(delay) {
    return openView('home', { page: '3' }, delay);
};

var goLogin = exports.goLogin = function goLogin() {
    var refresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var delay = arguments[1];
    return openView('login', { refresh: refresh }, delay);
};

var openUrl = exports.openUrl = function openUrl(url) {
    return openView('web', { url: encodeURIComponent(url) });
};

var selectShop = exports.selectShop = function selectShop(current) {
    return openView('selectCity', { currentcity: current });
};

var openOutSide = exports.openOutSide = function openOutSide(url) {
    return callNative('openOutSide', { url: url });
};

var getScreenInfo = exports.getScreenInfo = function getScreenInfo() {
    return callNative('getScreenInfo');
};

var openShare = exports.openShare = function openShare(params) {
    return callNative('shared', _extends({}, params));
};

var getTransactionPwd = exports.getTransactionPwd = function getTransactionPwd(params) {
    return callNative('getTransactionPwd', params);
};

var setTransactionPwd = exports.setTransactionPwd = function setTransactionPwd() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'set';
    return callNative('setTransactionPwd', { type: type });
};

var setFingerPayPwd = exports.setFingerPayPwd = function setFingerPayPwd() {
    var setPwdType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'firstSet';
    return callNative('setFingerPayPwd', { setPwdType: setPwdType });
};

var getCheckTradePwd = exports.getCheckTradePwd = function getCheckTradePwd(setPwdType) {
    return callNative('getCheckTradePwd', { setPwdType: setPwdType });
};

var getCity = exports.getCity = function getCity(currentCity) {
    return callNative('getCity', { currentCity: currentCity });
};

var ymTrack = exports.ymTrack = function ymTrack(evtName, label) {
    return callNative('event', { evtName: evtName, label: label });
};

var ymPageNameWithSeconds = exports.ymPageNameWithSeconds = function ymPageNameWithSeconds(pageData) {
    return callNative('pageNameWithSeconds', _extends({}, pageData));
};

var getDeviceInfo = exports.getDeviceInfo = function getDeviceInfo(action, params) {
    return callNative('getDeviceInfo', _extends({ action: action }, params));
};

var getRiskData = exports.getRiskData = function getRiskData(action) {
    return callNative('getRiskData', { action: action });
};

var startHwr = exports.startHwr = function startHwr(params) {
    return new Promise(function (resolve, reject) {
        var _err = {
            "typeAgain": "识别未通过，请重签",
            "typeSkip": "识别未通过，您可点击右上⻆选择跳过此步"
        };

        var realName = params.realName,
            agreement = params.agreement,
            errorNote = params.errorNote,
            _params$threshold = params.threshold,
            threshold = _params$threshold === undefined ? 5 : _params$threshold;


        errorNote = _extends({}, _err, errorNote);

        callNative('startHwr', { realName: realName, agreement: agreement, errorNote: errorNote, threshold: threshold }).then(function (res) {
            resolve(res);
        }, function (err) {
            reject(err);
        });
    });
};

var scanIdCard = exports.scanIdCard = function scanIdCard(cardSide) {
    var ocrType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ydbs';
    var pictureSourceType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'camera';
    return new Promise(function (resolve, reject) {
        callNative('getIdCard', { cardSide: cardSide, ocrType: ocrType, pictureSourceType: pictureSourceType }).then(function (res) {
            if (res && res.image) {
                resolve(res);
            } else {
                reject({ errorMessage: '扫描失败,稍后重试' });
            }
        }, function (err) {
            var _err$status = err.status,
                status = _err$status === undefined ? 'error_other' : _err$status;

            var errs = {
                'error_photo_access': '请打开像册权限',
                'error_camera_access': '请打开相机权限',
                'error_other': '获取图片失败'
            };

            reject({ errorMessage: errs[status] });
        });
    });
};

var sensorStart = exports.sensorStart = function sensorStart(params) {
    return callNative('startSensor', params);
};

var sensorStop = exports.sensorStop = function sensorStop(params) {
    return callNative('stopSensor', params);
};

var rateApp = exports.rateApp = function rateApp() {
    return callNative('rateApp');
};

var showToast = exports.showToast = function showToast(content) {
    return callNative('showToast', { toast_string: content });
};

var screenShots = exports.screenShots = function screenShots(action) {
    return callNative('creditScreenshots', { action: action });
};

var getImageInfo = exports.getImageInfo = function getImageInfo() {
    return new Promise(function (resolve, reject) {
        callNative('getImageInfo').then(function (res) {
            return resolve(res);
        }, function (err) {
            var errorMessage = '',
                errorStatus = err.status || 'error_other';
            switch (errorStatus) {
                case 'error_camera_access':
                    errorMessage = '请打开相机权限';
                    break;
                case 'error_photo_access':
                    errorMessage = '请打开相册权限';
                    break;
                case 'error_cancel':
                    errorMessage = '取消操作';
                    break;
                default:
                    errorMessage = '获取图片失败';
            }

            reject({ errorStatus: errorStatus, errorMessage: errorMessage });
        });
    });
};

var getCallandContact = exports.getCallandContact = function getCallandContact(actionType, isPopup) {
    return callNative('getCallandContact', { actionType: actionType, isPopup: isPopup });
};

var scanFace = exports.scanFace = function scanFace(actionTime) {
    return new Promise(function (resolve, reject) {

        callNative('checkLive', { actionTime: actionTime }).then(function (res) {
            return resolve(res);
        }, function (err) {
            var errorMessage = '',
                errorStatus = err.status || 'error_other';
            switch (errorStatus) {
                case 'error_cancel':
                    errorMessage = '操作取消';
                    break;
                case 'error_camera_access':
                    errorMessage = '无法访问摄像头';
                    break;
                case 'error_timeout':
                    errorMessage = '扫描超时';
                    break;
                case 'error_facelost':
                    errorMessage = '脸部丢失';
                    break;
                case 'error_mask':
                    errorMessage = '带着面罩';
                    break;
                case 'error_action':
                    errorMessage = '动作错误';
                    break;
                default:
                    errorMessage = '扫描人脸出错请重试';
                    break;
            }

            reject({ errorStatus: errorStatus, errorMessage: errorMessage });
        });
    });
};

document.addEventListener('jsBridgeReady', function (bridge) {
    if (__fn_stack.length) {
        __fn_stack.forEach(function (fn) {
            fn && typeof fn === 'function' && fn();
        });
        __fn_stack = [];
    }
    if (!window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge = bridge;
    }
}, false);

/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchActivityInfo = fetchActivityInfo;
exports.fetchRankingList = fetchRankingList;
exports.fetchImageInfo = fetchImageInfo;
exports.refreshActivityImageUrl = refreshActivityImageUrl;
exports.recordMarketingMobile = recordMarketingMobile;

var _http = __webpack_require__(18);

function fetchActivityInfo(params, opts) {
  return (0, _http.$GET)('/api/v1/activity/userPrize', params, opts);
}

function fetchRankingList(params, opts) {
  return (0, _http.$GET)('/api/v1/activity/rankinglist', params, opts);
}

function fetchImageInfo(pageCode, params, opts) {
  return (0, _http.$GET)('/query/imageInfo/' + pageCode, params, opts);
}

function refreshActivityImageUrl(body, opts) {
  return (0, _http.$POST)('/api/v1/refreshActivityImageUrl', body, opts);
}

function recordMarketingMobile(body, opts) {
  return (0, _http.$POST)('/api/v1/marketing/mobile/records', body, opts);
}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchNewsDetail = fetchNewsDetail;

var _http = __webpack_require__(18);

function fetchNewsDetail(params) {
  return (0, _http.$GET)('/api/v1/news', params);
}

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(256)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(249),
  /* scopeId */
  "data-v-84462ec0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(254)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(141),
  /* template */
  __webpack_require__(247),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 70 */,
/* 71 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(252)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(144),
  /* template */
  __webpack_require__(245),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(253)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(246),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 73 */,
/* 74 */,
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getWechatShareLink = getWechatShareLink;
exports.initWechatShare = initWechatShare;

var _tools = __webpack_require__(24);

var _index = __webpack_require__(19);

var JSSDK_URL = '//res.wx.qq.com/open/js/jweixin-1.6.0.js';
var DEFAULT_SHARE_IMG = '/timesloanh5/brand/assets/imgs/logo.png';
var BRAND_PATH_PREFIX = '/timesloanh5/brand';

var wxConfigReady = false;
var lastShareOptions = null;

function logShare() {
    console.log.apply(console, ['[wx-share]'].concat([].slice.call(arguments)));
}

function isWxDebug() {
    return (/[?&]wxdebug=1(?:&|$)/.test(location.href)
    );
}

function loadWxSdk() {
    if (typeof wx !== 'undefined') {
        return Promise.resolve();
    }
    return new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.src = JSSDK_URL;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
    });
}

function normalizeBrandEntryUrl() {
    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;

    var isBrandRoot = pathname === BRAND_PATH_PREFIX || pathname === BRAND_PATH_PREFIX + '/';

    if (!isBrandRoot) {
        return;
    }

    var nextPath = BRAND_PATH_PREFIX + '/index.html';
    history.replaceState(null, '', nextPath + search + hash);
    window.__wxSignPageUrl = location.href.split('#')[0];
}

function getWxSignPageUrl() {
    normalizeBrandEntryUrl();
    return window.__wxSignPageUrl || location.href.split('#')[0];
}

function getWechatShareLink() {
    normalizeBrandEntryUrl();
    var href = location.href;
    if (/\/timesloanh5\/brand#\//.test(href)) {
        href = href.replace('/timesloanh5/brand#/', '/timesloanh5/brand/index.html#/');
    }
    if (/\/timesloanh5\/brand\/#\//.test(href)) {
        href = href.replace('/timesloanh5/brand/#/', '/timesloanh5/brand/index.html#/');
    }
    return href;
}

function setMetaTag(property, content) {
    if (!content) return;
    var el = document.querySelector('meta[property="' + property + '"]');
    if (!el) {
        el = document.createElement('meta');
        el.setAttribute('property', property);
        document.head.appendChild(el);
    }
    el.setAttribute('content', content);
}

function updatePageMeta(_ref) {
    var title = _ref.title,
        desc = _ref.desc,
        imgUrl = _ref.imgUrl;

    if (title) {
        document.title = title;
        setMetaTag('og:title', title);
    }
    if (desc) {
        setMetaTag('og:description', desc);
    }
    if (imgUrl) {
        setMetaTag('og:image', imgUrl);
    }
}

function logWxApiFail(apiName, err) {
    var msg = err && err.errMsg || '';
    logShare(apiName + ' fail', err);
    if (msg.indexOf('offline verifying') > -1) {
        logShare('offline verifying：后台已显示分享接口有权限时，多为签名服务 appId/jsapi_ticket 与当前公众号不一致，' + '或访问域名不在 JS 安全域名列表、ticket 缓存过期。请后端核对 jsSignature 使用的 AppID 与 test 环境域名。');
    }
}

function setupShareInReady() {
    if (!wxConfigReady || !lastShareOptions) return;

    var _lastShareOptions = lastShareOptions,
        title = _lastShareOptions.title,
        desc = _lastShareOptions.desc,
        link = _lastShareOptions.link,
        imgUrl = _lastShareOptions.imgUrl;

    logShare('wx.ready 设置分享', { title: title, desc: desc, link: link, imgUrl: imgUrl });

    if (isWxDebug() && wx.checkJsApi) {
        wx.checkJsApi({
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'],
            success: function success(res) {
                logShare('checkJsApi', res.checkResult);
            },
            fail: function fail(err) {
                logShare('checkJsApi fail', err);
            }
        });
    }

    wx.updateAppMessageShareData({
        title: title,
        desc: desc,
        link: link,
        imgUrl: imgUrl,
        success: function success() {
            logShare('updateAppMessageShareData ok');
        },
        fail: function fail(err) {
            logWxApiFail('updateAppMessageShareData', err);
        }
    });

    wx.updateTimelineShareData({
        title: title,
        link: link,
        imgUrl: imgUrl,
        success: function success() {
            logShare('updateTimelineShareData ok');
        },
        fail: function fail(err) {
            logWxApiFail('updateTimelineShareData', err);
        }
    });

    if (wx.onMenuShareAppMessage) {
        wx.onMenuShareAppMessage({ title: title, desc: desc, link: link, imgUrl: imgUrl, type: 'link' });
    }
    if (wx.onMenuShareTimeline) {
        wx.onMenuShareTimeline({ title: title, link: link, imgUrl: imgUrl });
    }
}

function configWxSdk(pageUrl) {
    logShare('签名 pageUrl', pageUrl);

    return (0, _index.wxSignature)(pageUrl).then(function (data) {
        var timestamp = Number(data.timestamp || data.timeStamp);

        logShare('签名返回 appId', data.appId, '当前访问 host', location.host);

        return new Promise(function (resolve, reject) {
            wx.config({
                debug: isWxDebug(),
                appId: data.appId,
                timestamp: timestamp,
                nonceStr: data.nonceStr,
                signature: data.signature,
                jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareAppMessage', 'onMenuShareTimeline']
            });

            wx.ready(function () {
                wxConfigReady = true;
                logShare('wx.config ok');
                setupShareInReady();
                resolve();
            });

            wx.error(function (err) {
                logShare('wx.config fail', err);
                reject(err);
            });
        });
    });
}

function bindShareOnPageShow() {
    if (window.__wxSharePageShowBound) return;
    window.__wxSharePageShowBound = true;
    window.addEventListener('pageshow', function () {
        logShare('pageshow 重新设置分享');
        setupShareInReady();
    });
}

function initWechatShare() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (!_tools.OS.isWechat) {
        return Promise.resolve();
    }

    var pageUrl = getWxSignPageUrl();
    var _options$title = options.title,
        title = _options$title === undefined ? '万达商户贷' : _options$title,
        _options$desc = options.desc,
        desc = _options$desc === undefined ? '万达广场商户专属，最高额度50万，当天放款，循环额度>>' : _options$desc,
        _options$link = options.link,
        link = _options$link === undefined ? getWechatShareLink() : _options$link,
        _options$imgUrl = options.imgUrl,
        imgUrl = _options$imgUrl === undefined ? location.origin + DEFAULT_SHARE_IMG : _options$imgUrl;


    lastShareOptions = {
        title: title,
        desc: desc,
        link: link || getWechatShareLink(),
        imgUrl: imgUrl
    };

    updatePageMeta(lastShareOptions);
    bindShareOnPageShow();

    logShare('开始初始化', lastShareOptions, 'host', location.host);

    return loadWxSdk().then(function () {
        return configWxSdk(pageUrl);
    }).catch(function (err) {
        logShare('初始化失败', err);
    });
}

/***/ }),
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (window) {
  var svgSprite = '<svg><symbol id="icon-refresh" viewBox="0 0 1024 1024"><path d="M939.456 256.224c-16.672-5.984-34.976 2.72-40.896 19.36l-24.768 69.344c-28.992-65.312-74.784-122.72-133.088-165.92C555.328 41.728 291.296 79.232 152.32 262.656c-67.264 88.768-95.616 198.176-79.84 308.032 15.84 110.304 74.208 207.776 164.352 274.496 75.424 55.808 163.808 82.752 251.456 82.752 128.032 0 254.56-57.44 336.992-166.272 36.48-48.128 61.472-102.08 74.208-160.416 3.776-17.248-7.136-34.304-24.416-38.08-17.216-3.712-34.304 7.104-38.08 24.416-10.784 49.184-31.872 94.752-62.72 135.456-117.888 155.52-341.92 187.232-499.392 70.72-76.288-56.48-125.664-138.912-139.072-232.16-13.344-92.8 10.656-185.248 67.488-260.288 117.856-155.584 341.792-187.424 499.328-70.848 57.024 42.24 99.84 100.608 122.976 166.624l-109.984-42.944c-16.416-6.368-35.008 1.696-41.44 18.176-6.432 16.48 1.728 35.008 18.176 41.44l161.856 63.2c3.808 1.472 7.744 2.208 11.616 2.208 0.544 0 1.024-0.192 1.568-0.224 1.216 0.128 2.432 0.64 3.648 0.64 13.12 0 25.472-8.16 30.112-21.248l57.632-161.184C964.768 280.48 956.096 262.144 939.456 256.224z"  ></path></symbol><symbol id="icon-mobile" viewBox="0 0 1024 1024"><path d="M293 66c-33.137 0-60 26.863-60 60v773c0 33.137 26.863 60 60 60h438c33.137 0 60-26.863 60-60V126c0-33.137-26.863-60-60-60H293z m0-64h438c68.483 0 124 55.517 124 124v773c0 68.483-55.517 124-124 124H293C224.517 1023 169 967.483 169 899V126C169 57.517 224.517 2 293 2z"  ></path><path d="M416 128l192 0 0 64-192 0 0-64Z"  ></path><path d="M512 832m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z"  ></path></symbol><symbol id="icon-verify" viewBox="0 0 1024 1024"><path d="M126 269v-15c0-17.673 14.327-32 32-32h706c17.673 0 32 14.327 32 32v16c0 17.673 14.327 32 32 32 17.673 0 32-14.327 32-32v-16c0-53.02-42.98-96-96-96H158c-53.02 0-96 42.98-96 96v15c0 17.673 14.327 32 32 32 17.673 0 32-14.327 32-32zM126 754v15c0 17.673 14.327 32 32 32h706c17.673 0 32-14.327 32-32v-16c0-17.673 14.327-32 32-32 17.673 0 32 14.327 32 32v16c0 53.02-42.98 96-96 96H158c-53.02 0-96-42.98-96-96v-15c0-17.673 14.327-32 32-32 17.673 0 32 14.327 32 32z"  ></path><path d="M271.44 363.12c-10.08 10.92-22.68 20.58-37.8 29.82-15.12 8.4-28.98 14.28-42.42 17.64v45.36c27.72-7.98 50.82-20.58 68.88-37.8V663h45.78V363.12h-34.44z m204.54-5.88c-31.92 0-57.96 10.5-77.28 32.34-18.9 20.16-28.56 47.04-28.98 80.64h45.78c0.84-24.36 5.88-42.42 15.96-55.02 9.66-13.02 23.94-19.32 42.84-19.32 17.64 0 31.5 4.2 40.74 12.6 9.24 8.4 13.86 21 13.86 37.8 0 17.64-7.14 34.02-20.58 49.14-8.4 8.82-22.68 20.16-42.84 34.44-34.02 23.52-56.7 41.58-67.62 54.6-20.16 22.68-29.82 48.72-29.82 78.54h206.64v-40.32H424.74c6.3-16.38 25.62-35.28 57.96-56.7 29.82-20.16 50.4-36.12 62.16-48.3 19.32-21.42 29.4-44.94 29.4-70.98 0-26.46-9.24-47.88-27.3-64.68-18.48-16.8-42.42-24.78-70.98-24.78z m250.32 0c-29.4 0-53.34 7.98-71.82 24.78-19.74 16.8-30.66 39.9-33.18 69.72h44.94c1.68-18.48 7.98-32.34 18.06-41.58 10.08-9.24 24.36-13.86 42.42-13.86 17.64 0 31.5 3.78 40.74 12.18 8.4 7.98 13.02 19.32 13.02 34.44 0 15.12-5.04 26.88-14.28 34.86-9.24 7.98-23.1 12.18-41.58 12.18H703.2v34.44h21.84c19.74 0 34.86 4.2 44.94 12.6 10.92 8.4 16.38 21.42 16.38 39.06 0 15.12-5.46 27.3-15.54 37.38-11.76 10.92-27.3 16.8-46.62 16.8-17.64 0-31.92-5.04-42.84-15.12-12.6-10.92-18.9-26.46-19.74-46.62h-46.2c2.52 33.6 14.28 59.22 35.28 76.86 18.48 15.54 43.26 23.52 73.92 23.52 31.92 0 58.38-9.24 78.54-26.88 18.9-17.64 28.56-40.32 28.56-68.04 0-17.64-5.04-32.34-15.12-43.68-9.24-10.92-22.68-19.32-40.32-24.78 32.76-10.92 49.56-33.18 49.56-65.94 0-25.62-9.24-45.78-26.88-60.48-18.48-14.7-42.42-21.84-72.66-21.84z"  ></path></symbol></svg>';var script = function () {
    var scripts = document.getElementsByTagName("script");return scripts[scripts.length - 1];
  }();var shouldInjectCss = script.getAttribute("data-injectcss");var ready = function ready(fn) {
    if (document.addEventListener) {
      if (~["complete", "loaded", "interactive"].indexOf(document.readyState)) {
        setTimeout(fn, 0);
      } else {
        var loadFn = function loadFn() {
          document.removeEventListener("DOMContentLoaded", loadFn, false);fn();
        };document.addEventListener("DOMContentLoaded", loadFn, false);
      }
    } else if (document.attachEvent) {
      IEContentLoaded(window, fn);
    }function IEContentLoaded(w, fn) {
      var d = w.document,
          done = false,
          init = function init() {
        if (!done) {
          done = true;fn();
        }
      };var polling = function polling() {
        try {
          d.documentElement.doScroll("left");
        } catch (e) {
          setTimeout(polling, 50);return;
        }init();
      };polling();d.onreadystatechange = function () {
        if (d.readyState == "complete") {
          d.onreadystatechange = null;init();
        }
      };
    }
  };var before = function before(el, target) {
    target.parentNode.insertBefore(el, target);
  };var prepend = function prepend(el, target) {
    if (target.firstChild) {
      before(el, target.firstChild);
    } else {
      target.appendChild(el);
    }
  };function appendSvg() {
    var div, svg;div = document.createElement("div");div.innerHTML = svgSprite;svgSprite = null;svg = div.getElementsByTagName("svg")[0];if (svg) {
      svg.setAttribute("aria-hidden", "true");svg.style.position = "absolute";svg.style.width = 0;svg.style.height = 0;svg.style.overflow = "hidden";prepend(svg, document.body);
    }
  }if (shouldInjectCss && !window.__iconfont__svg__cssinject__) {
    window.__iconfont__svg__cssinject__ = true;try {
      document.write("<style>.svgfont {display: inline-block;width: 1em;height: 1em;fill: currentColor;vertical-align: -0.1em;font-size:16px;}</style>");
    } catch (e) {
      console && console.log(e);
    }
  }ready(appendSvg);
})(window);

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {};

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      downUrl: '',
      tip: false,
      isWx: false,
      isIos: false
    };
  },

  methods: {
    closeTip: function closeTip() {
      this.tip = false;
    },
    handleDownload: function handleDownload() {
      if (this.isWx) {
        this.tip = true;
      } else if (this.downUrl) {
        window.location.href = this.downUrl;
      }
    },
    initDownloadEnv: function initDownloadEnv() {
      var ua = navigator.userAgent;
      this.isWx = ua.toLowerCase().match(/MicroMessenger/i) === 'micromessenger';
      this.isIos = /iPhone|iPad|iPod|iOS/i.test(ua);
      if (this.isWx) {
        this.tip = true;
      } else if (this.isIos) {
        this.downUrl = 'https://apps.apple.com/cn/app/id1117322012';
      } else {
        this.downUrl = 'https://kyh.wandaloans.com/apkdownload/wdd.apk';
      }
    }
  },
  mounted: function mounted() {
    this.initDownloadEnv();
  }
};

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(255)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(142),
  /* template */
  __webpack_require__(248),
  /* scopeId */
  "data-v-784201dc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(257)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(145),
  /* template */
  __webpack_require__(250),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 111 */,
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * clipboard.js v2.0.4
 * https://zenorocha.github.io/clipboard.js
 * 
 * Licensed MIT © Zeno Rocha
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ClipboardJS"] = factory();
	else
		root["ClipboardJS"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clipboardAction = __webpack_require__(1);

var _clipboardAction2 = _interopRequireDefault(_clipboardAction);

var _tinyEmitter = __webpack_require__(3);

var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

var _goodListener = __webpack_require__(4);

var _goodListener2 = _interopRequireDefault(_goodListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Base class which takes one or more elements, adds event listeners to them,
 * and instantiates a new `ClipboardAction` on each click.
 */
var Clipboard = function (_Emitter) {
    _inherits(Clipboard, _Emitter);

    /**
     * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
     * @param {Object} options
     */
    function Clipboard(trigger, options) {
        _classCallCheck(this, Clipboard);

        var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));

        _this.resolveOptions(options);
        _this.listenClick(trigger);
        return _this;
    }

    /**
     * Defines if attributes would be resolved using internal setter functions
     * or custom functions that were passed in the constructor.
     * @param {Object} options
     */


    _createClass(Clipboard, [{
        key: 'resolveOptions',
        value: function resolveOptions() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
            this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
            this.text = typeof options.text === 'function' ? options.text : this.defaultText;
            this.container = _typeof(options.container) === 'object' ? options.container : document.body;
        }

        /**
         * Adds a click event listener to the passed trigger.
         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
         */

    }, {
        key: 'listenClick',
        value: function listenClick(trigger) {
            var _this2 = this;

            this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
                return _this2.onClick(e);
            });
        }

        /**
         * Defines a new `ClipboardAction` on each click event.
         * @param {Event} e
         */

    }, {
        key: 'onClick',
        value: function onClick(e) {
            var trigger = e.delegateTarget || e.currentTarget;

            if (this.clipboardAction) {
                this.clipboardAction = null;
            }

            this.clipboardAction = new _clipboardAction2.default({
                action: this.action(trigger),
                target: this.target(trigger),
                text: this.text(trigger),
                container: this.container,
                trigger: trigger,
                emitter: this
            });
        }

        /**
         * Default `action` lookup function.
         * @param {Element} trigger
         */

    }, {
        key: 'defaultAction',
        value: function defaultAction(trigger) {
            return getAttributeValue('action', trigger);
        }

        /**
         * Default `target` lookup function.
         * @param {Element} trigger
         */

    }, {
        key: 'defaultTarget',
        value: function defaultTarget(trigger) {
            var selector = getAttributeValue('target', trigger);

            if (selector) {
                return document.querySelector(selector);
            }
        }

        /**
         * Returns the support of the given action, or all actions if no action is
         * given.
         * @param {String} [action]
         */

    }, {
        key: 'defaultText',


        /**
         * Default `text` lookup function.
         * @param {Element} trigger
         */
        value: function defaultText(trigger) {
            return getAttributeValue('text', trigger);
        }

        /**
         * Destroy lifecycle.
         */

    }, {
        key: 'destroy',
        value: function destroy() {
            this.listener.destroy();

            if (this.clipboardAction) {
                this.clipboardAction.destroy();
                this.clipboardAction = null;
            }
        }
    }], [{
        key: 'isSupported',
        value: function isSupported() {
            var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];

            var actions = typeof action === 'string' ? [action] : action;
            var support = !!document.queryCommandSupported;

            actions.forEach(function (action) {
                support = support && !!document.queryCommandSupported(action);
            });

            return support;
        }
    }]);

    return Clipboard;
}(_tinyEmitter2.default);

/**
 * Helper function to retrieve attribute value.
 * @param {String} suffix
 * @param {Element} element
 */


function getAttributeValue(suffix, element) {
    var attribute = 'data-clipboard-' + suffix;

    if (!element.hasAttribute(attribute)) {
        return;
    }

    return element.getAttribute(attribute);
}

module.exports = Clipboard;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _select = __webpack_require__(2);

var _select2 = _interopRequireDefault(_select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Inner class which performs selection from either `text` or `target`
 * properties and then executes copy or cut operations.
 */
var ClipboardAction = function () {
    /**
     * @param {Object} options
     */
    function ClipboardAction(options) {
        _classCallCheck(this, ClipboardAction);

        this.resolveOptions(options);
        this.initSelection();
    }

    /**
     * Defines base properties passed from constructor.
     * @param {Object} options
     */


    _createClass(ClipboardAction, [{
        key: 'resolveOptions',
        value: function resolveOptions() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.action = options.action;
            this.container = options.container;
            this.emitter = options.emitter;
            this.target = options.target;
            this.text = options.text;
            this.trigger = options.trigger;

            this.selectedText = '';
        }

        /**
         * Decides which selection strategy is going to be applied based
         * on the existence of `text` and `target` properties.
         */

    }, {
        key: 'initSelection',
        value: function initSelection() {
            if (this.text) {
                this.selectFake();
            } else if (this.target) {
                this.selectTarget();
            }
        }

        /**
         * Creates a fake textarea element, sets its value from `text` property,
         * and makes a selection on it.
         */

    }, {
        key: 'selectFake',
        value: function selectFake() {
            var _this = this;

            var isRTL = document.documentElement.getAttribute('dir') == 'rtl';

            this.removeFake();

            this.fakeHandlerCallback = function () {
                return _this.removeFake();
            };
            this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;

            this.fakeElem = document.createElement('textarea');
            // Prevent zooming on iOS
            this.fakeElem.style.fontSize = '12pt';
            // Reset box model
            this.fakeElem.style.border = '0';
            this.fakeElem.style.padding = '0';
            this.fakeElem.style.margin = '0';
            // Move element out of screen horizontally
            this.fakeElem.style.position = 'absolute';
            this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
            // Move element to the same position vertically
            var yPosition = window.pageYOffset || document.documentElement.scrollTop;
            this.fakeElem.style.top = yPosition + 'px';

            this.fakeElem.setAttribute('readonly', '');
            this.fakeElem.value = this.text;

            this.container.appendChild(this.fakeElem);

            this.selectedText = (0, _select2.default)(this.fakeElem);
            this.copyText();
        }

        /**
         * Only removes the fake element after another click event, that way
         * a user can hit `Ctrl+C` to copy because selection still exists.
         */

    }, {
        key: 'removeFake',
        value: function removeFake() {
            if (this.fakeHandler) {
                this.container.removeEventListener('click', this.fakeHandlerCallback);
                this.fakeHandler = null;
                this.fakeHandlerCallback = null;
            }

            if (this.fakeElem) {
                this.container.removeChild(this.fakeElem);
                this.fakeElem = null;
            }
        }

        /**
         * Selects the content from element passed on `target` property.
         */

    }, {
        key: 'selectTarget',
        value: function selectTarget() {
            this.selectedText = (0, _select2.default)(this.target);
            this.copyText();
        }

        /**
         * Executes the copy operation based on the current selection.
         */

    }, {
        key: 'copyText',
        value: function copyText() {
            var succeeded = void 0;

            try {
                succeeded = document.execCommand(this.action);
            } catch (err) {
                succeeded = false;
            }

            this.handleResult(succeeded);
        }

        /**
         * Fires an event based on the copy operation result.
         * @param {Boolean} succeeded
         */

    }, {
        key: 'handleResult',
        value: function handleResult(succeeded) {
            this.emitter.emit(succeeded ? 'success' : 'error', {
                action: this.action,
                text: this.selectedText,
                trigger: this.trigger,
                clearSelection: this.clearSelection.bind(this)
            });
        }

        /**
         * Moves focus away from `target` and back to the trigger, removes current selection.
         */

    }, {
        key: 'clearSelection',
        value: function clearSelection() {
            if (this.trigger) {
                this.trigger.focus();
            }

            window.getSelection().removeAllRanges();
        }

        /**
         * Sets the `action` to be performed which can be either 'copy' or 'cut'.
         * @param {String} action
         */

    }, {
        key: 'destroy',


        /**
         * Destroy lifecycle.
         */
        value: function destroy() {
            this.removeFake();
        }
    }, {
        key: 'action',
        set: function set() {
            var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';

            this._action = action;

            if (this._action !== 'copy' && this._action !== 'cut') {
                throw new Error('Invalid "action" value, use either "copy" or "cut"');
            }
        }

        /**
         * Gets the `action` property.
         * @return {String}
         */
        ,
        get: function get() {
            return this._action;
        }

        /**
         * Sets the `target` property using an element
         * that will be have its content copied.
         * @param {Element} target
         */

    }, {
        key: 'target',
        set: function set(target) {
            if (target !== undefined) {
                if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
                    if (this.action === 'copy' && target.hasAttribute('disabled')) {
                        throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                    }

                    if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
                        throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                    }

                    this._target = target;
                } else {
                    throw new Error('Invalid "target" value, use a valid Element');
                }
            }
        }

        /**
         * Gets the `target` property.
         * @return {String|HTMLElement}
         */
        ,
        get: function get() {
            return this._target;
        }
    }]);

    return ClipboardAction;
}();

module.exports = ClipboardAction;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

function select(element) {
    var selectedText;

    if (element.nodeName === 'SELECT') {
        element.focus();

        selectedText = element.value;
    }
    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        var isReadOnly = element.hasAttribute('readonly');

        if (!isReadOnly) {
            element.setAttribute('readonly', '');
        }

        element.select();
        element.setSelectionRange(0, element.value.length);

        if (!isReadOnly) {
            element.removeAttribute('readonly');
        }

        selectedText = element.value;
    }
    else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
}

module.exports = select;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var is = __webpack_require__(5);
var delegate = __webpack_require__(6);

/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listen(target, type, callback) {
    if (!target && !type && !callback) {
        throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
        throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
        throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
        return listenNode(target, type, callback);
    }
    else if (is.nodeList(target)) {
        return listenNodeList(target, type, callback);
    }
    else if (is.string(target)) {
        return listenSelector(target, type, callback);
    }
    else {
        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
}

/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNode(node, type, callback) {
    node.addEventListener(type, callback);

    return {
        destroy: function() {
            node.removeEventListener(type, callback);
        }
    }
}

/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function(node) {
        node.addEventListener(type, callback);
    });

    return {
        destroy: function() {
            Array.prototype.forEach.call(nodeList, function(node) {
                node.removeEventListener(type, callback);
            });
        }
    }
}

/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
}

module.exports = listen;


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.node = function(value) {
    return value !== undefined
        && value instanceof HTMLElement
        && value.nodeType === 1;
};

/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.nodeList = function(value) {
    var type = Object.prototype.toString.call(value);

    return value !== undefined
        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
        && ('length' in value)
        && (value.length === 0 || exports.node(value[0]));
};

/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.string = function(value) {
    return typeof value === 'string'
        || value instanceof String;
};

/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.fn = function(value) {
    var type = Object.prototype.toString.call(value);

    return type === '[object Function]';
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var closest = __webpack_require__(7);

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function _delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    }
}

/**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(elements, selector, type, callback, useCapture) {
    // Handle the regular Element usage
    if (typeof elements.addEventListener === 'function') {
        return _delegate.apply(null, arguments);
    }

    // Handle Element-less usage, it defaults to global delegation
    if (typeof type === 'function') {
        // Use `document` as the first parameter, then apply arguments
        // This is a short way to .unshift `arguments` without running into deoptimizations
        return _delegate.bind(null, document).apply(null, arguments);
    }

    // Handle Selector-based usage
    if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
    }

    // Handle Array-like based usage
    return Array.prototype.map.call(elements, function (element) {
        return _delegate(element, selector, type, callback, useCapture);
    });
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = closest(e.target, selector);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    }
}

module.exports = delegate;


/***/ }),
/* 7 */
/***/ (function(module, exports) {

var DOCUMENT_NODE_TYPE = 9;

/**
 * A polyfill for Element.matches()
 */
if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var proto = Element.prototype;

    proto.matches = proto.matchesSelector ||
                    proto.mozMatchesSelector ||
                    proto.msMatchesSelector ||
                    proto.oMatchesSelector ||
                    proto.webkitMatchesSelector;
}

/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */
function closest (element, selector) {
    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
        if (typeof element.matches === 'function' &&
            element.matches(selector)) {
          return element;
        }
        element = element.parentNode;
    }
}

module.exports = closest;


/***/ })
/******/ ]);
});

/***/ }),
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            isHidden: false,
            keys: [[{
                text: '1',
                value: 1
            }, {
                text: '2',
                value: 2
            }, {
                text: '3',
                value: 3
            }], [{
                text: '4',
                value: 4
            }, {
                text: '5',
                value: 5
            }, {
                text: '6',
                value: 6
            }], [{
                text: '7',
                value: 7
            }, {
                text: '8',
                value: 8
            }, {
                text: '9',
                value: 9
            }], [{
                text: '',
                value: null
            }, {
                text: '0',
                value: 0
            }, {
                text: '',
                value: 'delete'
            }]]
        };
    },

    methods: {
        handleClick: function handleClick(value) {
            this.$emit("input", value);
        }
    }
};

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _wui = __webpack_require__(11);

exports.default = {
    name: 'c-primary-button',
    extends: _wui.Button,
    methods: {
        handleClick: function handleClick(evt) {
            this.$emit('click', evt);
        }
    },
    computed: {
        opts: function opts() {
            return !this.plain ? {
                bgColor: '#00c2e0',
                fontColor: '#fff'
            } : {
                bgColor: '#fff',
                fontColor: '#00c2e0'
            };
        }
    }
};

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _numberKeyboard = __webpack_require__(68);

var _numberKeyboard2 = _interopRequireDefault(_numberKeyboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        numberKeyboard: _numberKeyboard2.default
    },
    props: {
        pwd: Array,
        leftText: String,
        rightText: String
    },
    data: function data() {
        return {
            inputed: this.pwd
        };
    },

    watch: {
        'pwd': function pwd(newValue) {
            if (Array.isArray(newValue) && newValue.length === 0) {
                this.inputed = newValue;
            }
        }
    },
    methods: {
        handleInput: function handleInput(value) {
            if (value === "delete") {
                this.inputed.length > 0 && this.inputed.pop();
            } else if (value >= 0 && value <= 9) {
                this.inputed.length < 6 && this.inputed.push(value);
            }
            if (this.inputed.length === 6) {
                this._completeInput();
            }
        },
        forgotPassword: function forgotPassword() {
            this.$emit("hidden");
            this.$wui.Dialog.show({
                content: '请登录万达财富App后重置交易密码',
                buttons: [{
                    text: '暂不重置'
                }, {
                    text: '去重置',
                    action: function action() {
                        return console.log('去重置');
                    }
                }]
            });
        },
        handleHidden: function handleHidden() {
            this.$emit("hidden");
        },
        _completeInput: function _completeInput() {
            var pwd = this.inputed.join('');
            this.$emit("complete", pwd);
        }
    }
};

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        datas: Array
    },
    data: function data() {
        return {
            list: [],
            currentIndex: ''
        };
    },

    methods: {
        showAnswer: function showAnswer(index) {
            var target = this.list[index];
            if (this.currentIndex === index) {
                this.currentIndex = '';
            } else {
                this.currentIndex = index;
                target = this.list[this.currentIndex];
            }

            if (target) {
                this.$nextTick(function () {
                    target.querySelector('.list-answer').scrollIntoView();
                });
            }
        },
        openAnswer: function openAnswer() {}
    },
    mounted: function mounted() {
        var _this = this;

        this.$nextTick(function () {
            _this.list = _this.$el.querySelectorAll('li');
        });
    }
};

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _native = __webpack_require__(17);

var _clipboard = __webpack_require__(112);

var _clipboard2 = _interopRequireDefault(_clipboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'b-share',
    props: {
        isShow: {
            type: Boolean,
            default: false
        },
        opts: {
            type: Object,
            default: function _default() {
                return {
                    url: '',
                    desc: '',
                    title: '',
                    thumbImage: ''
                };
            }
        }
    },
    data: function data() {
        return {
            visiable: this.isShow,
            options: this.opts
        };
    },

    watch: {
        isShow: function isShow(val) {
            this.visiable = val;
        },
        opts: function opts(val) {
            this.options = val;
        }
    },
    methods: {
        openQr: function openQr() {
            this.$emit('open-qrimg');
        },
        shareTo: function shareTo(t) {
            var opts = _extends({}, this.options, { type: t });
            _native.openShare.apply(this, [opts]);
        },
        show: function show() {
            this.visiable = true;
            this.$emit('open', this);
        },
        hide: function hide() {
            this.visiable = false;
            this.$emit('close', this);
        }
    },
    mounted: function mounted() {
        var _this = this;

        var clipboard = new _clipboard2.default('.w-clipboard-data-text');
        clipboard.on('success', function () {
            _this.$wui.Toast.show({
                content: '复制成功',
                pos: 'middle'
            });
        });
    }
};

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    name: 'c-steps',
    props: {
        steps: Array,
        width: Number
    },

    methods: {
        lineStyle: function lineStyle($i) {
            var w = this.width / this.steps.length;
            return {
                width: w - 20 + 'px',
                left: w * ($i - 1 + 0.5) + 10 + 'px'
            };
        }
    }
};

/***/ }),
/* 146 */,
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    host: '',
    port: '',
    base: '/timesloan',
    debug: false
};

/***/ }),
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".mgm-share-box{background:#fff;position:absolute;left:0;bottom:0;width:100%;height:240px;z-index:1}.mgm-share-box .mgm-share-item{height:56px;width:56px}.mgm-share-box .mgm-share-item>img{width:100%;height:100%}.mgm-share-box .mgm-share-box-title{height:40px;text-align:center;line-height:40px}.mgm-share-box .mgm-share-box-targets,.mgm-share-box .mgm-share-box-tools{padding-left:10px;height:100px;font-size:12px;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center}", ""]);

// exports


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".brand-question-answer{width:100%}.brand-question-answer .brand-padding-15px{box-sizing:border-box;padding-left:15px;padding-right:15px}.brand-question-answer .qa-list:last-child:after{border:none}.brand-question-answer .qa-list>div{display:inherit;padding-top:15px;padding-bottom:15px}.brand-question-answer .qa-list .list-question{width:100%;font-size:16px;color:#222;line-height:20px;text-align:left;display:-webkit-box;display:-webkit-flex;display:flex}.brand-question-answer .qa-list .list-question .list-question-content{display:block;-webkit-box-flex:1;-webkit-flex:1;flex:1}.brand-question-answer .qa-list .list-question .triangle{width:20px;display:block;position:relative}.brand-question-answer .qa-list .list-question .triangle:after{position:absolute;right:0;top:35%;content:\" \";display:inline-block;-webkit-transform:rotate(135deg);transform:rotate(135deg);height:6px;width:6px;border-width:2px 2px 0 0;border-color:#c8c8cd;border-style:solid}.brand-question-answer .qa-list .list-answer{background-color:#fafafa;font-size:14px;display:-webkit-box;display:-webkit-flex;display:flex}.brand-question-answer .qa-list .list-answer .list-answer-a{background:#00a1f4;width:18px;height:18px;line-height:18px;border-radius:100%;font-size:12px;color:#fff;text-align:center;display:inline-block}.brand-question-answer .qa-list .list-answer .list-answer-content{-webkit-box-flex:1;-webkit-flex:1;flex:1;padding-left:10px;font-size:14px;color:#666;line-height:22px}", ""]);

// exports


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".cash-primary-button.wui-button.is-plain:after{border-color:#00c2e0}", ""]);

// exports


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".pwd-keyboard[data-v-784201dc]{height:100%;position:relative}.pwd-keyboard .keyboard-wrapper[data-v-784201dc]{position:absolute;bottom:0;left:0;right:0}.custom-area[data-v-784201dc]{padding:10px;position:relative;font-size:14px}.custom-area__action-content[data-v-784201dc]{padding-left:5px}.pwd-desc[data-v-784201dc]{height:50px;font-size:14px;color:#666;line-height:14px}.input-box-wrapper[data-v-784201dc]{height:50px;position:relative}.forgot-pwd[data-v-784201dc]{padding:18px}.forgot-pwd__button[data-v-784201dc]{font-size:14px;color:#478df5;line-height:14px}.input-box[data-v-784201dc]{height:100%;position:relative}.input-box.inputed[data-v-784201dc]:before{content:\"\";width:14px;height:14px;border-radius:7px;background-color:#478df5}", ""]);

// exports


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".keyboard-title[data-v-84462ec0]{background:#f5f7f9;box-shadow:0 0 0 0 #d9d9d9,0 0 0 0 #d9d9d9,inset 0 0 0 0 #d9d9d9;width:100%;height:32px;font-size:14px;color:#999;line-height:32px;text-align:center;position:relative}.keyboard-title .hidden-button[data-v-84462ec0]{position:absolute;height:32px;width:40px;top:0;right:0}.keyboard-title .hidden-button[data-v-84462ec0]:after{content:\"\";height:10px;width:10px;border-right:1px solid silver;border-bottom:1px solid silver;position:absolute;right:15px;top:40%;-webkit-transition:-webkit-transform .5s ease .4s;transition:-webkit-transform .5s ease .4s;transition:transform .5s ease .4s;transition:transform .5s ease .4s,-webkit-transform .5s ease .4s;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.keyboard-title .hidden-button.is-hidden[data-v-84462ec0]:after{-webkit-transform:rotate(225deg);transform:rotate(225deg)}.keyboard-keys[data-v-84462ec0]{height:200px;-webkit-transition:height .5s ease;transition:height .5s ease;overflow:hidden}@media screen and (device-width:320px) and (device-height:480px) and (-webkit-device-pixel-ratio:2){.keyboard-keys[data-v-84462ec0]{height:160px}}.keyboard-keys.keys-hidden[data-v-84462ec0]{height:0}.keyboard-key[data-v-84462ec0]{height:50px;background-color:#fff;position:relative}@media screen and (device-width:320px) and (device-height:480px) and (-webkit-device-pixel-ratio:2){.keyboard-key[data-v-84462ec0]{height:40px}}.keyboard-key.delete-key[data-v-84462ec0],.keyboard-key.empty-key[data-v-84462ec0]{background-color:#f5f7f9;box-shadow:0 0 0 0 #d9d9d9,0 0 0 0 #d9d9d9,inset 0 0 0 0 #d9d9d9,inset 0 0 0 0 #d9d9d9}.keyboard-key[data-v-84462ec0]:not(.empty-key):active{background-color:#e2e5ea;box-shadow:0 0 0 0 #d9d9d9,0 0 0 0 #d9d9d9,inset 0 0 0 0 #d9d9d9,inset 0 0 0 0 #d9d9d9}.keyboard-key.delete-key[data-v-84462ec0]{background-image:url(" + __webpack_require__(226) + ");background-repeat:no-repeat;background-position:50% 50%;background-size:40px;font-size:16px}.keyboard-key.delete-key[data-v-84462ec0]:not(.empty-key):active{background-image:url(" + __webpack_require__(225) + ")}.keyboard-button[data-v-84462ec0]{width:100px;font-size:30px;color:#222;height:50px;line-height:50px;text-align:center}@media screen and (device-width:320px) and (device-height:480px) and (-webkit-device-pixel-ratio:2){.keyboard-button[data-v-84462ec0]{height:40px;line-height:40px}}", ""]);

// exports


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".cash-steps{position:relative;margin:0 auto;background:#fff;height:72px;box-sizing:border-box;padding-top:10px}.cash-steps .cash-steps-box{display:-webkit-box;display:-webkit-flex;display:flex;width:100%;position:absolute;z-index:1}.cash-steps .cash-steps-item{-webkit-box-flex:1;-webkit-flex:1;flex:1;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column;color:#a3acb3}.cash-steps .cash-steps-item,.cash-steps .cash-steps-item .cash-steps-icon{-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:flex}.cash-steps .cash-steps-item .cash-steps-icon{width:30px;height:30px;border-radius:50%;text-align:center;box-sizing:border-box;background:#f7f7f7;color:silver}.cash-steps .cash-steps-item .cash-steps-label{line-height:32px;font-size:14px;color:#999}.cash-steps .cash-steps-item.is-current .cash-steps-icon{background-color:#00bfe0;color:#fff;border:0;line-height:30px}.cash-steps .cash-steps-item.is-current .cash-steps-label{color:#00bfe0}.cash-steps .cash-steps-item.is-disable{opacity:.5}.cash-steps .cash-steps-line-box{position:absolute;top:25px;height:2px;font-size:0;line-height:0;width:100%}.cash-steps .cash-steps-line-box .cash-steps-line{border-bottom:2px solid #d9d9d9;position:absolute}.cash-steps .cash-steps-line-box .cash-steps-line.is-current{border-color:#00bfe0}.cash-steps .cash-steps-line-box .cash-steps-line.is-disable{opacity:.5}", ""]);

// exports


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "imgs/delete-hover.png";

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "imgs/delete.png";

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "imgs/share-link@2x.png";

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "imgs/share-qq@2x.png";

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "imgs/share-qr@2x.png";

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "imgs/share-qzone@2x.png";

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "imgs/share-wechat-area@2x.png";

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "imgs/share-wechat@2x.png";

/***/ }),
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(243);
var objectAssign = __webpack_require__(239);
var decodeComponent = __webpack_require__(202);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

function extract(str) {
	var queryStart = str.indexOf('?');
	if (queryStart === -1) {
		return '';
	}
	return str.slice(queryStart + 1);
}

function parse(str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^[?#&]/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeComponent(val);

		formatter(decodeComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	if (opts.sort === false) {
		opts.sort = function () {};
	}

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};

exports.parseUrl = function (str, opts) {
	return {
		url: str.split('?')[0] || '',
		query: parse(extract(str), opts)
	};
};


/***/ }),
/* 241 */,
/* 242 */,
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 244 */,
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('w-mask', {
    attrs: {
      "is-show": _vm.isShow
    },
    on: {
      "click": _vm.hide
    }
  }, [_c('transition', {
    attrs: {
      "name": "bottom"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "mgm-share-box"
  }, [_c('div', {
    staticClass: "mgm-share-box-title"
  }, [_vm._v("\n                立即邀请好友\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "wui-border-1px wui-border-b mgm-share-box-tools"
  }, [_c('w-row', [_c('w-cell', {
    attrs: {
      "width": "72"
    },
    on: {
      "click": _vm.openQr
    }
  }, [_c('w-col', [_c('w-cell', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "mgm-share-item"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(229),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('w-cell', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n                                当面扫码\n                            ")])], 1)], 1), _vm._v(" "), _c('w-cell', {
    attrs: {
      "width": "72"
    }
  }, [_c('w-col', {
    staticClass: "w-clipboard-data-text",
    attrs: {
      "data-clipboard-text": _vm.options.url
    }
  }, [_c('w-cell', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "mgm-share-item"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(227),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('w-cell', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n                                复制链接\n                            ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mgm-share-box-targets"
  }, [_c('w-row', [_c('w-cell', {
    attrs: {
      "width": "72"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.shareTo('0')
      }
    }
  }, [_c('w-col', [_c('w-cell', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "mgm-share-item"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(232),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('w-cell', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n                                微信好友\n                            ")])], 1)], 1), _vm._v(" "), _c('w-cell', {
    attrs: {
      "width": "72"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.shareTo('1')
      }
    }
  }, [_c('w-col', [_c('w-cell', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "mgm-share-item"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(231),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('w-cell', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n                                朋友圈\n                            ")])], 1)], 1), _vm._v(" "), _c('w-cell', {
    attrs: {
      "width": "72"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.shareTo('2')
      }
    }
  }, [_c('w-col', [_c('w-cell', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "mgm-share-item"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(228),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('w-cell', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n                                QQ\n                            ")])], 1)], 1), _vm._v(" "), _c('w-cell', {
    attrs: {
      "width": "72"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.shareTo('3')
      }
    }
  }, [_c('w-col', [_c('w-cell', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "mgm-share-item"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(230),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('w-cell', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n                                QQ空间\n                            ")])], 1)], 1)], 1)], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 246 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "brand-question-answer"
  }, [_c('ul', _vm._l((_vm.datas), function(data, index) {
    return _c('li', {
      key: index,
      staticClass: "qa-list wui-border-1px wui-border-b",
      on: {
        "click": function($event) {
          return _vm.showAnswer(index)
        }
      }
    }, [_c('div', {
      staticClass: "list-question brand-padding-15px"
    }, [_c('span', {
      staticClass: "list-question-content"
    }, [_vm._v(_vm._s(data.question))]), _vm._v(" "), _c('span', {
      staticClass: "triangle"
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.currentIndex === index),
        expression: "currentIndex === index"
      }],
      staticClass: "list-answer brand-padding-15px"
    }, [_c('span', {
      staticClass: "list-answer-a"
    }, [_vm._v("答")]), _vm._v(" "), _c('div', {
      staticClass: "list-answer-content",
      attrs: {
        "id": ""
      }
    }, _vm._l((data.answer), function(answer) {
      return _c('p', [_vm._v(_vm._s(answer.answerQues || ' '))])
    }), 0)])])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 247 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('w-button', {
    staticClass: "cash-primary-button",
    attrs: {
      "width": _vm.width,
      "height": _vm.height,
      "plain": _vm.plain,
      "bg-color": _vm.opts.bgColor,
      "sharp": _vm.sharp,
      "disabled": _vm.disabled,
      "font-color": _vm.opts.fontColor
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 248 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "pwd-keyboard"
  }, [_c('w-row', {
    staticClass: "pwd-desc"
  }, [_c('w-cell', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("请输入6位交易密码")])], 1), _vm._v(" "), _c('w-row', {
    staticClass: "pwd-input-box",
    staticStyle: {
      "justify-content": "center"
    },
    attrs: {
      "align": "center",
      "height": 50
    }
  }, [_c('w-cell', {
    staticClass: "input-box-wrapper wui-border-1px",
    attrs: {
      "width": 300
    }
  }, _vm._l((6), function(i) {
    return _c('w-cell', {
      key: i,
      staticClass: "input-box",
      class: {
        'inputed': _vm.inputed && _vm.inputed[i - 1] >= 0
      },
      attrs: {
        "width": 50,
        "align": "center"
      }
    })
  }), 1)], 1), _vm._v(" "), _c('w-row', {
    staticClass: "forgot-pwd",
    staticStyle: {
      "justify-content": "flex-end"
    },
    attrs: {
      "align": "right"
    }
  }, [_c('w-cell', {
    attrs: {
      "width": 80
    }
  }, [_c('span', {
    staticClass: "forgot-pwd__button",
    on: {
      "click": _vm.forgotPassword
    }
  }, [_vm._v("忘记密码?")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "keyboard-wrapper"
  }, [_c('number-keyboard', {
    on: {
      "input": _vm.handleInput
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 249 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "password-keyboard"
  }, [_c('div', {
    staticClass: "keyboard__wrapper"
  }, [_c('div', {
    staticClass: "keyboard-title"
  }, [_vm._v("\n            安全键盘\n            "), _c('span', {
    staticClass: "hidden-button",
    class: {
      'is-hidden': _vm.isHidden
    },
    on: {
      "click": function($event) {
        _vm.isHidden = !_vm.isHidden
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "keyboard-keys wui-border-1px",
    class: {
      'keys-hidden': _vm.isHidden
    }
  }, _vm._l((_vm.keys), function(line) {
    return _c('w-row', {
      key: line.$index
    }, _vm._l((line), function(ref) {
      var text = ref.text;
      var value = ref.value;

      return _c('w-cell', {
        key: text,
        staticClass: "keyboard-key",
        class: {
          'empty-key': value === null, 'delete-key': value === 'delete'
        },
        attrs: {
          "vertical-align": "center",
          "align": "center"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.handleClick(value)
          }
        }
      }, [_c('span', {
        staticClass: "keyboard-button"
      }, [_vm._v(_vm._s(text))])])
    }), 1)
  }), 1)])])
},staticRenderFns: []}

/***/ }),
/* 250 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cash-steps",
    style: ({
      width: _vm.width + 'px'
    })
  }, [_c('div', {
    staticClass: "cash-steps-box"
  }, _vm._l((_vm.steps), function(step, $i) {
    return _c('div', {
      staticClass: "cash-steps-item",
      class: {
        'is-current': step.current, 'is-disable': step.disable
      }
    }, [_c('span', {
      staticClass: "cash-steps-icon"
    }, [_c('w-icon', {
      attrs: {
        "width": 16,
        "height": 16,
        "fill": step.current ? '#fff' : '#c0c0c0',
        "type": step.iconName
      }
    })], 1), _vm._v(" "), _c('span', {
      staticClass: "cash-steps-label"
    }, [_vm._v(_vm._s(step.text))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "cash-steps-line-box"
  }, _vm._l((_vm.steps.length), function($i) {
    return ($i < _vm.steps.length) ? _c('span', {
      staticClass: "cash-steps-line",
      class: {
        'is-current': _vm.steps[$i].current, 'is-disable': _vm.steps[$i].disable
      },
      style: (_vm.lineStyle($i))
    }) : _vm._e()
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 251 */,
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(196);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(8).default
var update = add("3f8dfa4c", content, true, {});

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(197);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(8).default
var update = add("2ffef84f", content, true, {});

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(198);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(8).default
var update = add("31400c96", content, true, {});

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(199);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(8).default
var update = add("56f9cbe5", content, true, {});

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(200);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(8).default
var update = add("1505cb6c", content, true, {});

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(201);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(8).default
var update = add("13b38450", content, true, {});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = listToStyles;
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(36);
__webpack_require__(68);
__webpack_require__(69);
__webpack_require__(109);
__webpack_require__(72);
__webpack_require__(71);
__webpack_require__(110);
__webpack_require__(37);
__webpack_require__(38);
__webpack_require__(18);
__webpack_require__(98);
__webpack_require__(42);
__webpack_require__(17);
__webpack_require__(39);
__webpack_require__(75);
__webpack_require__(99);
__webpack_require__(100);
__webpack_require__(66);
__webpack_require__(19);
__webpack_require__(67);
module.exports = __webpack_require__(24);


/***/ })
],[262]);


// WEBPACK FOOTER //
// js/libs.c658cc9708.js